import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { StorageService } from '../../services/storage.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  hidePassword = true;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: ApiService,
    private store: StorageService,
    private notify: NotificationService
  ) {
    this.loginForm = this.fb.group({
      userName: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit(): void {}

  onSubmit(): void {
    if (this.loginForm.invalid) return;

    this.isLoading = true;

    const { userName, password } = this.loginForm.value;

    this.http
      .post('retailers/login', {
        appId: 2,
        loginType: 1,
        username: userName,
        password,
        notifyToken: '',
      })
      .subscribe({
        next: (res) => {
          console.log('res', res);
          if (res.code === 1) {
            this.store.set({
              appId: 2,
              apikey: res.data.apikey,
              acc_type: res.data.acc_type,
              userId: res.data.userId,
              termsAccepted: res.data.termsAccepted ? 'true' : 'false',
              termsAgreeDate: res.data.termsAgreeDate,
              termsUpdatedDate: res.data.termsUpdatedDate,
              getWAConsentByUser: res.data.getWAConsentByUser,
              companyName: res.data.companyName,
              is_admin: res.data.is_admin,
              enquiryConfig: res.data.enquiryConfig,
            });
            this.router.navigate(['/dashboard']);
          } else {
            this.notify.showError(res.message, '');
          }
        },
        error: (err) => {
          console.error('Login error:', err);
          this.notify.showError(
             'Login failed. Please try again.',
             ''
          );
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  getErrorMessage(field: string): string {
    if (this.loginForm.get(field)?.hasError('required')) {
      return `${field === 'userName' ? 'Username' : 'Password'} is required`;
    }
    if (field === 'userName' && this.loginForm.get('userName')?.hasError('minlength')) {
      return 'Username must be at least 3 characters long';
    }
    if (field === 'password' && this.loginForm.get('password')?.hasError('minlength')) {
      return 'Password must be at least 6 characters long';
    }
    return '';
  }
} 
